import React from 'react';
import {
  Alert, Col, Form,
  Row,
} from 'react-bootstrap';

interface SocialLinksSectionProps {
  instagramUsername: string;
  tiktokUsername: string;
  instagramError: string | null;
  tiktokError: string | null;
  onInstagramChange: (value: string) => void;
  onTiktokChange: (value: string) => void;
}

export function SocialLinksSection({
  instagramUsername,
  tiktokUsername,
  instagramError,
  tiktokError,
  onInstagramChange,
  onTiktokChange,
}: SocialLinksSectionProps) {
  const handleInstagramChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    onInstagramChange(value);
  };

  const handleTiktokChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    onTiktokChange(value);
  };

  return (
    <Alert variant="light" className="my-3">
      <Row>
        <Col md="auto" className="font-weight-bold">
          Social links:
        </Col>
      </Row>
      <Row>
        <Col>
          <Form.Group controlId="instagramUsername" className="mb-1" as={Row}>
            <Form.Label column sm={2}>Instagram:</Form.Label>
            <Col sm={10}>
              <Form.Control
                type="text"
                placeholder="Enter username"
                name="instagramUsername"
                value={instagramUsername}
                isInvalid={!!instagramError}
                onChange={handleInstagramChange}
              />
            </Col>
          </Form.Group>
          <Form.Group controlId="tiktokUsername" as={Row} className="mb-0">
            <Form.Label column sm={2}>TikTok:</Form.Label>
            <Col sm={10}>
              <Form.Control
                type="text"
                placeholder="Enter username"
                name="tiktokUsername"
                value={tiktokUsername}
                isInvalid={!!tiktokError}
                onChange={handleTiktokChange}
              />
            </Col>
          </Form.Group>
        </Col>
      </Row>
    </Alert>
  );
}
